"use client";

// Reserves the desktop rail's width. Split out of the shell layout so the
// layout itself stays a server component while the width still tracks the
// collapse state.

import Sidebar from "./Sidebar";
import { useSidebar } from "./SidebarProvider";

export default function SidebarRail() {
  const { collapsed } = useSidebar();

  return (
    <div
      className={`lg:shrink-0 transition-[width] duration-300 ease-out ${
        collapsed ? "lg:w-[84px]" : "lg:w-[248px]"
      }`}
    >
      <Sidebar />
    </div>
  );
}
